var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-5"},[_c('v-row',{staticClass:"mx-0 page-header",attrs:{"align":"center"}},[_c('span',{staticClass:"px-5 py-2 text-h6 font-weight-regular"},[_vm._t("title")],2),_c('v-spacer'),_vm._t("action")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }